var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"w-24 h-24 mb-4",attrs:{"alt":"logo image","src":require("../assets/farm-logo.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }